import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.form?.addEventListener(
      'turbo:submit-start',
      this.submitStart.bind(this)
    )
    this.form?.addEventListener('turbo:submit-end', this.submitEnd.bind(this))
  }

  disconnect() {
    this.form?.removeEventListener(
      'turbo:submit-start',
      this.submitStart.bind(this)
    )
    this.form?.removeEventListener(
      'turbo:submit-end',
      this.submitEnd.bind(this)
    )
  }

  submitStart(event) {
    const targetFrame = this.getTargetFrame(event)

    if (targetFrame && targetFrame === this.frame?.id) {
      this.frame?.setAttribute('aria-busy', 'true')
    }
  }

  submitEnd(event) {
    const targetFrame = this.getTargetFrame(event)

    if (targetFrame && targetFrame === this.frame?.id) {
      this.frame?.removeAttribute('aria-busy')
    }
  }

  getTargetFrame(event) {
    return event?.detail?.formSubmission?.submitter?.dataset?.turboFrame
  }

  get form() {
    return this.element.closest('form')
  }

  get frame() {
    return this.element.closest('turbo-frame')
  }
}
